export default __webpack_public_path__ + "static/media/bg.fcbf5eaf.jpg";